import * as React from 'react';
import classNames from 'classnames';
import { Header4 } from '@cian/ui-kit/typography';
import { TButtonTheme, TTextColor } from './types';
import * as styles from './Button.css';

interface IButton extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon?: React.ReactElement;
  size?: 'small';
  theme?: TButtonTheme;
  testId?: string;
  disabled?: boolean;
}

const textColor: TTextColor = {
  blue: 'primary_100',
  orange: 'white_100',
};

export function Button(props: IButton) {
  const { type = 'button', onClick, children, icon, size, theme = 'orange', testId, disabled } = props;
  const color = textColor[theme];

  return (
    <button
      className={classNames(
        styles['button'],
        { [styles['button_small']]: size === 'small' },
        { [styles['button_blue']]: theme === 'blue' },
      )}
      onClick={onClick}
      type={type}
      data-testid={testId}
      disabled={disabled}
    >
      {icon && <span className={styles['button__icon']}>{icon}</span>}
      <Header4 color={color} fontWeight="bold">
        {children}
      </Header4>
    </button>
  );
}
